<template>
  <div
    v-bind:style='{left:obj.view.left + "px", top:obj.view.top + "px", width:getWidth() + "px", height:obj.view.h + "px"}'
    class='flowchart-object jsplumb-draggable jsplumb-droppable'
    :class="getNodeClass()"
    :id="obj.data.id"
  >

    <out-state
      v-if="obj.type==='outState'"
      :answer-title=obj.data.title
      :remove="deleteNode"
    />

    <in-out-state
      v-if="obj.type==='inOutState'"
      :answer-title=obj.data.title
      :answer-state-question=obj.data.stateQuestion
      :answer-state-value=obj.data.stateValue
      :answer-words=obj.data.words
      :answer-is-illegibly="obj.data.isIllegibly"
      :answer-is-silence="obj.data.isSilence"
      :remove="deleteNode"
      :addWordsForAllByTitle="addWordsForAllByTitle"
    />

    <universal-answer
      v-if="obj.type !== 'inOutState' && obj.type !== 'outState'"
      :start-node="obj.startNode"
      :answer-id="obj.data.id"
      :answer-title=obj.data.title
      :answer-state-question=obj.data.stateQuestion
      :answer-transkrib-value=obj.data.useTranscribeByValue
      :answer-state-value=obj.data.stateValue
      :answer-words=obj.data.words
      :answer-audio='obj.data.audio'
      :answer-text='obj.data.text'
      :answer-generation-type="obj.data.generationAudioType"
      :answer-is-silence="obj.data.isSilence"
      :answer-is-illegibly="obj.data.isIllegibly"
      :answer-search-strategy="obj.data.searchStrategy"
      :answer-recognition-driver="obj.data.recognitionDriver"
      :answer-timeout="obj.data.timeout"
      :answer-start-collect-before-play-end="obj.data.startCollectBeforePlayEnd"
      :answer-waiting-input-timeout="obj.data.waitingInputTimeout"
      :answer-silence-after-speech-timeout="obj.data.silenceAfterSpeechTimeout"
      :answer-delay-before-collect="obj.data.delayBeforeCollect"
      :answer-current-emotion="obj.data.emotion"
      :answer-current-vendor="obj.data.vendor"
      :answer-current-lang="obj.data.lang"
      :answer-current-speaker="obj.data.speaker"
      :answer-current-speed="obj.data.speed"
      :answerGoogleSsmlType="obj.data.googleSsmlType"
      :answer-repeat="obj.data.repeat"
      :answer-simulated-delay-millis='obj.data.simulatedDelayMillis'
      :scenario-id="obj.scenarioId"
      :remove="deleteNode"
      :setNodeHeight="setNodeHeight"
      :setWindowSmall="setNodeSmall"
      :setWindowMedium="setNodeMedium"
      :setWindowBig="setNodeBig"
      :addWordsForAllByTitle="addWordsForAllByTitle"
      :get-scenario-lang="getScenarioLang"
    />
    <div class="add hidden_for_client_automation">
      <i
        class="fas fa-comment-medical add_answer"
        v-if="obj.type === 'inOutState'"
        v-bind:title="$t('common.actions.add') + ' ' + $t('scenarios.konstruktor.canvas.add.robotAnswer')"
        v-on:click="addAnswer(obj.availableSmsGateways)"
      ></i>
      <i
        class="fas fa-network-wired add_state"
        v-if="obj.type!=='inOutState'"
        v-bind:title="$t('common.actions.add') + ' ' + $t('scenarios.konstruktor.canvas.add.recognition')"
        v-on:click="addInOutState(obj.availableSmsGateways)"
      ></i>
      <i
        class="fas fa-user-tie add_redirect"
        v-bind:title="$t('common.actions.add') + ' ' + $t('scenarios.konstruktor.canvas.add.redirectToOperator')"
        v-on:click="addRedirect()"
      ></i>
      <i
        class="fab fa-connectdevelop connect"
        v-bind:title="$t('common.actions.connect')"
      ></i>
      <i
        class="fas fa-sms addSms"
        :class="obj.availableSmsGateways && obj.availableSmsGateways.length ? 'hasSmsGateways': ''"
        v-bind:title="$t('scenarios.konstruktor.canvas.add.sendSMS')"
        v-on:click="addSMS(null, null, obj.availableSmsGateways)"
      ></i>
      <i
        class="fas fa-file-code hidden_for_client addHttpRequest"
        v-bind:title="$t('scenarios.konstruktor.canvas.add.sendHttpRequest')"
        v-on:click="addHttpRequest()"
      ></i>
    </div>
  </div>

</template>


<script>
import {BaseNodeComponent} from './jsplumb-extends/jsplumb-vue'
import UniversalAnswer from './UniversalAnswer'
import BaseComponent from '../BaseComponent'
import InOutState from './InOutState'
import OutState from './OutState'
// import i18n from '../../../translations/i18n'

export default {
  components: {OutState, InOutState, UniversalAnswer},
  mixins: [BaseNodeComponent],
  extends: BaseComponent,
  props: [],
  methods: {
    getScenarioLang() {
      let lang = 'ru-RU'
      let scenarioLangs = document.querySelectorAll('.scenarioLang')
      let scenarioLang = null
      if (scenarioLangs) {
        scenarioLang = scenarioLangs[scenarioLangs.length - 1]
        lang = scenarioLang.value
      }
      return lang
    },
    getVendor() {
      let obj = this.$el.querySelector('.vendor')
      if (obj) {
        return obj.value
      } else {
        return ''
      }
    },
    getSpeaker() {
      let obj = this.$el.querySelector('.voice')
      if (obj) {
        return obj.value
      } else {
        return ''
      }
    },
    addAnswer(availableSmsGateways) {
      if (this.hasRedirect()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.toAddRobotAnswerPleaseRemoveRedirectToOperator)
        return
      }

      let element = this.$el
      let thisComponent = this
      let toolkit = this.getToolkit()
      let sourceConnections = toolkit.getConnections({source: element.id, scope: '*'}, true)
      let data = {
        data: {
          audio: [],
          id: '',
          title: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.answer.answer + ' ' + (1 + sourceConnections.length),
          stateQuestion: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.answer.answer + ' ' + (1 + sourceConnections.length),
          lang: this.getScenarioLang(),
          vendor: this.getVendor(),
          speaker: this.getSpeaker()
        },
        view: {
          // w: 580,
          // h: 256,
          top: element.offsetTop + element.offsetHeight + 100,
          left: element.offsetLeft + ((element.clientWidth - 580) / 2.0)
        },
        titleEditable: true
      }
      let newComponent = toolkit.addNode(data, this.obj.scenarioId, availableSmsGateways)
      toolkit.addCustomConnection(thisComponent, newComponent)
    },
    addRedirect(redirectNumber, redirectView) {
      redirectView = redirectView || {}
      if (this.hasAnswers()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.toAddRedirectToOperatorPleaseRemoveAllRobotAnswers)
        return
      } else if (this.hasRedirect()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.thereIsAlreadyHasARedirectToOperator)
        return
      }

      let element = this.$el
      let toolkit = this.getToolkit()
      let data = {
        view: {
          w: redirectView.w || 256,
          h: redirectView.h || 128,
          top: redirectView.top || (element.offsetTop + element.offsetHeight + 64),
          left: redirectView.left || (element.offsetLeft + ((element.clientWidth - 256) / 2.0)),
          id: redirectView.id || null
        },
        redirect: redirectNumber || ''
      }
      let newComponent = toolkit.addRedirectNode(data)
      toolkit.addCustomConnection(this, newComponent)
    },
    addSMS(smsConfig, smsView, availableSmsGateways) {
      smsConfig = smsConfig || {}
      smsView = smsView || {}
      let element = this.$el
      let toolkit = this.getToolkit()
      let data = {
        view: {
          w: smsView.w || 430,
          h: smsView.h || 163,
          top: smsView.top || (element.offsetTop + element.offsetHeight + 64),
          left: smsView.left || (element.offsetLeft + ((element.clientWidth - 256) / 2.0)),
          id: smsView.id || null
        },
        data: {
          text: smsConfig.text || '',
          gateway: smsConfig.gateway || 'smsc',
          sender: smsConfig.sender || ''
        },
        availableSmsGateways: availableSmsGateways
      }
      let newComponent = toolkit.addSmsNode(data)
      toolkit.addCustomConnection(this, newComponent)
    },
    addHttpRequest(reqData, view) {
      reqData = reqData || {}
      view = view || {}
      let element = this.$el
      let toolkit = this.getToolkit()
      if (view.id && toolkit.allNodes[view.id]) {
        toolkit.addCustomConnection(this, toolkit.allNodes[view.id])
      } else {
        let data = {
          view: {
            w: view.w || 920,
            h: view.h || 256,
            top: view.top || (element.offsetTop + element.offsetHeight + 64),
            left: view.left || (element.offsetLeft + ((element.clientWidth - 256) / 2.0)),
            id: view.id || null
          },
          data: {
            method: reqData.method || 'GET',
            url: reqData.url || '',
            headers: reqData.headers || {'Content-Type': 'application/json'},
            params: reqData.params || [],
            body: reqData.body || ''
          }
        }
        let newComponent = toolkit.addHttpRequestNode(data)
        toolkit.addCustomConnection(this, newComponent)
      }
    },
    addInOutState(availableSmsGateways) {
      let element = this.$el
      let thisComponent = this
      let toolkit = this.getToolkit()
      let data = {
        type: 'inOutState',
        data: {
          id: '',
          title: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.add.recognition
        },
        view: {
          w: 300,
          h: 300,
          top: element.offsetTop + element.offsetHeight + 100,
          left: element.offsetLeft + ((element.clientWidth - 580) / 2.0)
        }
      }
      let newComponent = toolkit.addNode(data, this.obj.scenarioId, availableSmsGateways)
      toolkit.addCustomConnection(thisComponent, newComponent)
    },
    deleteNode() {
      let toolkit = this.getToolkit()
      toolkit.customRemoveNode(this.$el.id)
    },
    hasRedirect() {
      let toolkit = this.getToolkit()
      let firstTarget = toolkit.getFirstTarget(this)
      if (firstTarget) {
        return firstTarget.isRedirect
      } else {
        return false
      }
    },
    hasAnswers() {
      let toolkit = this.getToolkit()
      let firstTarget = toolkit.getFirstTarget(this)
      if (firstTarget) {
        return firstTarget.isAnswer
      } else {
        return false
      }
    },
    hasSms() {
      let toolkit = this.getToolkit()
      let allTargets = toolkit.getAllTargets(this)
      for (let i = 0; i < allTargets.length; i++) {
        if (allTargets[i].isSms) {
          return true
        }
      }
      return false
    },
    getNodeClass() {
      let classStr = ''
      if (this.obj.startNode) {
        classStr += 'start-node '
      }
      if (this.obj.type === 'outState') {
        classStr += 'outState_shell '
      } else if (this.obj.type === 'inOutState') {
        classStr += 'inOutState_shell '
      } else {
        classStr += 'answer_shell '
      }
      classStr += (this.obj.view.windowType || '')
      // classStr += (' ConnectionsToTargetsSize-' + this.getConnectionsToTargetsSize(true))
      return classStr
    },
    // getConnectionsToTargetsSize(withoutSilenceAndIllegibly) {
    //     let toolkit = this.getToolkit()
    //     if (toolkit) {
    //         let connections = toolkit.getConnections({source:this.$el.id})
    //         if (connections && connections.length) {
    //             if (!withoutSilenceAndIllegibly) {
    //                 return connections.length
    //             } else {
    //                 let size = 0
    //                 for (let i = 0; i < connections.length; i++) {
    //                     let targetId = connections[i].targetId
    //                     let target = toolkit.allNodes[targetId]
    //                     if (target.$el.classList.contains('outState_shell')) {
    //                         return 3
    //                     } else {
    //                         let isSilenceObj = target.$el.querySelector('input.checkbox.isSilence')
    //                         let isIllegiblyObj = target.$el.querySelector('input.checkbox.isIllegibly')
    //                         let isSilence = isSilenceObj && isSilenceObj.checked
    //                         let isIllegibly = isIllegiblyObj && isIllegiblyObj.checked
    //                         if (!isSilence && !isIllegibly) {
    //                             size++
    //                         }
    //                     }
    //                 }
    //                 return size
    //             }
    //         } else {
    //             return 0
    //         }
    //     } else {
    //         return 0
    //     }
    // },
    setNodeHeight(count, notRepaint) {
      let newHeight
      if (this.obj.view.windowType === 'medium' || this.obj.view.windowType === 'small') {
        newHeight = this.getBaseHeight() + Math.floor(0 + count) * 32
      } else {
        newHeight = this.getBaseHeight() + Math.floor((1 + count) / 2) * 32
      }
      let heightChange = this.obj && this.obj.view && (!this.obj.view.h || this.obj.view.h !== newHeight)
      this.obj.view.h = newHeight
      if (heightChange && this.$el) {
        this.$el.style.height = newHeight + 'px'
      }
      if (!notRepaint && this.getToolkit()) {
        setInterval(this.getToolkit().repaintEverything, 500)
      }
    },
    setNodeWidth() {
      let newWidth = this.getWidth()
      let widthChange = this.obj && this.obj.view && (!this.obj.view.w || this.obj.view.w !== newWidth)
      this.obj.view.w = newWidth
      if (widthChange && this.$el) {
        this.$el.style.width = newWidth + 'px'
      }
    },
    setNodeMedium(repaint) {
      this.obj.view.windowType = 'medium'
      let validUrlCount = 0
      if (this.obj.data.audio && this.obj.data.audio.length) {
        for (let i = 0; i < this.obj.data.audio.length; i++) {
          if (this.obj.data.audio[i].url && this.obj.data.audio[i].type === 'url') {
            validUrlCount++
          }
        }
      }
      this.setNodeHeight(validUrlCount)
      this.setNodeWidth()
      this.$el.classList.remove('small')
      this.$el.classList.add('medium')
      this.$el.classList.remove('big')
      if (repaint) {
        setInterval(this.getToolkit().repaintEverything, 500)
      }
    },
    setNodeSmall(repaint) {
      this.obj.view.windowType = 'small'
      let validUrlCount = 0
      if (this.obj.data.audio && this.obj.data.audio.length) {
        for (let i = 0; i < this.obj.data.audio.length; i++) {
          if (this.obj.data.audio[i].url && this.obj.data.audio[i].type === 'url') {
            validUrlCount++
          }
        }
      }
      this.setNodeHeight(validUrlCount)
      this.setNodeWidth()
      this.$el.classList.add('small')
      this.$el.classList.remove('medium')
      this.$el.classList.remove('big')
      if (repaint) {
        setInterval(this.getToolkit().repaintEverything, 500)
      }
    },
    setNodeBig(repaint) {
      this.obj.view.windowType = 'big'
      let validUrlCount = 0
      if (this.obj.data.audio && this.obj.data.audio.length) {
        for (let i = 0; i < this.obj.data.audio.length; i++) {
          if (this.obj.data.audio[i].url && this.obj.data.audio[i].type === 'url') {
            validUrlCount++
          }
        }
      }
      this.setNodeHeight(validUrlCount)
      this.setNodeWidth()
      this.$el.classList.remove('small')
      this.$el.classList.remove('medium')
      this.$el.classList.add('big')
      if (repaint) {
        setInterval(this.getToolkit().repaintEverything, 500)
      }
    },
    getBaseHeight() {
      if (this.obj.type === 'outState') {
        return 64
      } else if (this.obj.type === 'inOutState') {
        return 300
      } else {
        if (this.obj.view.windowType === 'medium') {
          return 162
        } else if (this.obj.view.windowType === 'small') {
          return 80
        } else {
          if (this.obj.startNode) {
            return 240
          } else {
            return 223
          }
        }
      }
    },
    getWidth() {
      if (this.obj.type === 'outState') {
        return 666
      } else if (this.obj.type === 'inOutState') {
        return 300
      } else {
        if (this.obj.view.windowType === 'medium') {
          return 400
        } else if (this.obj.view.windowType === 'small') {
          return 200
        } else {
          // if (this.obj.startNode) {
          //     return 780
          // } else {
          //     return 678
          // }
          return 805
        }
      }
    },
    addWordsForAllByTitle(data) {
      let allFlowchartObject = document.querySelectorAll('.flowchart-object')
      if (allFlowchartObject) {
        for (let i = 0; i < allFlowchartObject.length; i++) {
          let flowchartObject = allFlowchartObject[i]
          let titleObj = flowchartObject.querySelector('.title .answerTitle')
          let title = titleObj.outerText || titleObj.value
          if (title && data.title && (title.toLowerCase() === data.title.toLowerCase())) {
            let wordsEditorObj = flowchartObject.querySelector('.wordsEditor')
            let tagsObj = wordsEditorObj.querySelector('.tags-input.tags')
            let tags = tagsObj.getElementsByClassName('tag')
            for (let j = 0; j < data.tags.length; j++) {
              let hasTag = false
              if (tags) {
                for (let k = 0; k < tags.length && !hasTag; k++) {
                  if (tags[k].outerText.trim() === data.tags[j].trim()) {
                    hasTag = true
                  }
                }
              }
              if (!hasTag) {
                tagsObj.insertAdjacentHTML('beforeend', '<span class="tags-input-tag tag is-medium">' + data.tags[j] + '\n' + '<button type="button" class="tags-input-remove delete"></button></span>')
              }
            }
          }
        }
      }
    }
  },
  created() {
    let validUrlCount = 0
    if (this.obj.data.audio && this.obj.data.audio.length) {
      for (let i = 0; i < this.obj.data.audio.length; i++) {
        if (this.obj.data.audio[i].url && this.obj.data.audio[i].type === 'url') {
          validUrlCount++
        }
      }
    }
    this.setNodeHeight(validUrlCount)
  }
  // i18n: i18n
}

</script>

<style scoped>
@import "../../../../node_modules/@fortawesome/fontawesome-free/css/all.css";

.flowchart-object {
  vertical-align: top;
  /*background-color: ghostwhite;*/
  background-color: #eeeef1;
  padding: 10px;
}

.flowchart-object .add {
  position: absolute;
  color: lightgray;
  bottom: -16px;
  cursor: pointer;
}

.answer_shell .add {
  margin: auto;
  width: 100%;
  left: -6px;
}

.inOutState_shell .add {
  /*left: 86px*/
  width: 100%;
  margin: auto;
  left: -6px;
}

.outState_shell .add {
  left: 256px;
}

/*.answer_shell.medium .add {*/
/*  left: 160px;*/
/*}*/
/*.answer_shell.start-node .add {*/
/*  margin: auto;*/
/*  width: 100%;*/
/*}*/
/*.answer_shell.start-node.medium .add {*/
/*  left: 160px;*/
/*}*/
/*.answer_shell.small .add {*/
/*  left: 49px;*/
/*}*/
/*.answer_shell.start-node.small .add {*/
/*  left: 49px;*/
/*}*/
/*.answer_shell .add_answer:hover {*/
/*     color: gray;*/
/*}*/

.flowchart-object {
  border-radius: 10px;
}

.add i {
  color: lightgray;
  display: inline-block;
  font-size: x-large;
  /*margin: 0 1em 1em 0;*/
  margin-left: 3px;
  margin-right: 3px;
}

.add i:hover {
  color: gray;
  font-size: xx-large;
  /*margin: 0 1em 1em 0;*/
}

/*.add .add_redirect {*/
/*  margin-left:5px;*/
/*  margin-right: 5px;*/
/*}*/
/*.add .add_answer {*/
/*  margin-right:5px;*/
/*}*/
/*.add .connect {*/
/*  margin-left:5px;*/
/*}*/

.add .addSms {
  display: none;
}

.add .addSms,
.add .addHttpRequest {
  /*display:none;*/
}

.add .addSms.hasSmsGateways {
  display: inline-block;
}

.inOutState_shell .add .add_state {
  display: none;
}
</style>



// WEBPACK FOOTER //
// BaseEditableNode.vue?20a0f6c4